import { useEffect } from "react";
import { FiDownload } from "react-icons/fi";
import { assets } from "../../data/assets";
import { logAppEvent } from "../../modules/firebase";
import styles from "./Assets.module.scss";

const DownloadButton = (props) => {
  const handleDownload = (e) => {
    e.preventDefault();

    logAppEvent("download_asset", { label: props.label });
    // Convert Google Drive sharing link to direct download link
    let downloadUrl = props.link;

    // Check if it's a Google Drive link
    if (props.link && props.link.includes("drive.google.com")) {
      // Extract file ID from Google Drive share link
      // Format: https://drive.google.com/file/d/{FILE_ID}/view?usp=sharing
      const fileIdMatch = props.link.match(/\/d\/([a-zA-Z0-9-_]+)/);
      if (fileIdMatch && fileIdMatch[1]) {
        const fileId = fileIdMatch[1];
        downloadUrl = `https://drive.google.com/uc?export=download&id=${fileId}`;
      }
    }

    // Create a temporary anchor element to trigger download
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", props.label || "download");
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <button
      onClick={handleDownload}
      className={styles.downloadButton}
      aria-label={`Download ${props.label}`}
    >
      <div>{props.label}</div>
      <FiDownload />
    </button>
  );
};

export const Assets = () => {
  useEffect(() => {
    logAppEvent("view_assets_page");
  }, []);

  return (
    <div className={styles.assets}>
      <h3 className={styles.assetsTitle}>Assets</h3>
      <div className={styles.grid}>
        {assets.map((asset, index) => (
          <div className={styles.assetItem} key={index}>
            <h4 className={styles.assetTitle}>{asset.title}</h4>
            <div className={styles.assetDescription}>{asset.description}</div>
            <img src={asset.image} className={styles.assetImage} />
            <div className={styles.assetDetails}>
              Components: {asset.components}
            </div>
            <div className={styles.downloadButtons}>
              {asset.links.map((link, linkIndex) => (
                <DownloadButton
                  key={linkIndex}
                  label={link.label}
                  link={link.url}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
